import React from "react";
import { CardPageItem } from "../custom/Page";
import {
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@material-ui/core";
import useHasPermissions from "../hooks/useHasPermission";
import { DIALOG_OPTION, HierarchyViewTypeEnum, Permissions } from "../util";
import FormChangeRecommender from "./components/FormChangeRecommender";
import { FormattedMessage } from "react-intl";
import { ChevronRight } from "@material-ui/icons";
import RemoveRecommender from "./components/Management/Dialogs/RemoveRecommender";
import { changeRecommender } from "../actions";

const CustomerManagementActions = ({ currentUser, user, fetchUser }) => {
  const [selectedDialog, setSelectedDialog] = React.useState(null);
  const { hasPermission } = useHasPermissions(user);

  const handleDialog = React.useCallback((dialog) => setSelectedDialog(dialog), []);
  const handleClose = React.useCallback(() => setSelectedDialog(null), []);

  const actionsMenu = React.useMemo(
    () =>
      [
        {
          id: "edit-recommender",
          dialogOption: DIALOG_OPTION.EDIT_RECOMMENDER,
          canShow: hasPermission([Permissions.EDIT_RECOMMENDER, Permissions.REMOVE_RECOMMENDER]),
          label: user.recommender ? "app.changeRecommender" : "app.addRecommender",
          onClick: () => handleDialog(DIALOG_OPTION.EDIT_RECOMMENDER),
          DialogComponent: FormChangeRecommender,
          dialogProps: {
            onClose: handleClose,
            onSuccess: fetchUser,
            user,
            currentUser,
            hierarchyViewType: HierarchyViewTypeEnum.DIRECTLY,
            actionEditRecommender: changeRecommender,
          },
        },
        {
          id: "remove-recommender",
          dialogOption: DIALOG_OPTION.REMOVE_RECOMMENDER,
          canShow: !!user.recommender && hasPermission([Permissions.EDIT_RECOMMENDER, Permissions.REMOVE_RECOMMENDER]),
          label: "app.recommender.clear",
          onClick: () => handleDialog(DIALOG_OPTION.REMOVE_RECOMMENDER),
          DialogComponent: RemoveRecommender,
          dialogProps: { onClose: handleClose, fetchUser, user },
        },
      ].filter(({ canShow }) => canShow),
    [hasPermission, handleClose, fetchUser, user, currentUser, handleDialog],
  );

  if (!actionsMenu.length) return null;

  return (
    <CardPageItem raised margin={1}>
      <CardContent>
        <Typography variant="subtitle1" align="center">
          <FormattedMessage id="app.actions" />
        </Typography>
        <List>
          {actionsMenu.map(({ id, label, onClick }) => (
            <ListItem key={id} button onClick={onClick}>
              <ListItemText
                primary={
                  <Typography>
                    <FormattedMessage id={label} />
                  </Typography>
                }
              />
              <ListItemIcon>
                <ChevronRight />
              </ListItemIcon>
            </ListItem>
          ))}
        </List>

        {actionsMenu.map(({ dialogOption, DialogComponent, dialogProps }) => (
          <DialogComponent
            key={dialogOption}
            open={selectedDialog === dialogOption}
            {...dialogProps}
          />
        ))}
      </CardContent>
    </CardPageItem>
  );
};

export default CustomerManagementActions;
